<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="History Logs" :path="breadcrumbPath" />
    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-row :gutter="$vuetify.display.width > 1200 ? 10 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 14 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="filter.search"
                        :placeholder="'Type to search by user name, email, form kind, action kind ...'"
                        :prefix-icon="Search"
                        class="mixedSearchBar-2"
                        id="mixedSearchBar-input-2"
                        clearable
                        @clear="handleReload"
                    >
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <!-- export button -->
              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 10 : 24"
                  >
                  <el-date-picker
                        v-model="filter.searchByDate"
                        type="date"
                        placeholder="Filter table by log date"
                        size="default"
                        class="w-100 height-40"
                        :class="'x-end mr-2'"
                        format="DD/MM/YYYY"
                        date-format="DD/MM/YYYY"
                        value-format="YYYY-MM-DD"
                      />
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior x-end"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
              </el-col>
            </el-row>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="historyDataList"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <ShowDetail
      :open_modal="show_modal"
      :data_modal="data_modal"
      @close_modal="close_modal"
    />

    <ChargerUploadDetail
      :open_modal="show_charger_upload_modal"
      :data_modal="charger_upload_data_modal"
      @close_modal="close_charger_upload_modal"
    />

    <SessionUploadDetail
      :open_modal="show_session_upload_modal"
      :data_modal="session_upload_data_modal"
      @close_modal="close_session_upload_modal"
    />

    <RenewablesUploadDetail
      :open_modal="show_renewables_upload_modal"
      :data_modal="renewables_upload_data_modal"
      @close_modal="close_renewables_upload_modal"
    />

    <SessionReallocationDetail
      :open_modal="show_session_reallocation_modal"
      :data_modal="session_reallocation_data_modal"
      @close_modal="close_session_reallocation_modal"
    />

    <OverlapSessDetail
      :open_modal="show_overlap_sess_modal"
      :data_modal="overlap_sess_data_modal"
      @close_modal="close_overlap_sess_modal"
    />

    <UpdateDetail
      :open_modal="show_update_detail_modal"
      :data_modal="update_detail_data_modal"
      @close_modal="close_update_detail_modal"
    />

    <MotionBucketDownloadDetail
      :open_modal="show_motion_bucket_download_modal"
      :data_modal="motion_bucket_download_data_modal"
      @close_modal="close_motion_bucket_download_modal"
    />

    <ResetElecRegionDetail
      :open_modal="show_reset_elec_region_modal"
      :data_modal="reset_elec_region_data_modal"
      @close_modal="close_reset_elec_region_modal"
    />

  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import { exportToExcel } from "../dashboard/common/exportExcel";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";
// import Filter from "./filter.vue";
import ShowDetail from "./dialogDetail.vue";
import ChargerUploadDetail from "./chargerUploadDetail.vue";
import SessionUploadDetail from "./sessionUploadDetail.vue";
import RenewablesUploadDetail from "./renewablesUploadDetail.vue";
import SessionReallocationDetail from "./sessionReallocationDetail.vue";
import OverlapSessDetail from "./overlapSessDetail.vue";
import UpdateDetail from "./updateDetail.vue";
import MotionBucketDownloadDetail from "./motionBucketDownloadDetail.vue";
import ResetElecRegionDetail from "./resetElecRegionDetail.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "historyLogs",
  components: {
    Breadcrumbs,
    // Filter,
    ShowDetail,
    DataTable,
    ChargerUploadDetail,
    SessionUploadDetail,
    RenewablesUploadDetail,
    SessionReallocationDetail,
    OverlapSessDetail,
    UpdateDetail,
    MotionBucketDownloadDetail,
    ResetElecRegionDetail,
  },
  data() {
    return {
      breadcrumbPath: [
        {
          title: "Support",
          disabled: true,
          href: "",
        },
        {
          title: "History Logs",
          disabled: false,
          href: "/history-logs",
          active: true,
        },
      ],

      show: true,
      historyDataList: [],
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,

      // charger upload 
      show_charger_upload_modal: false,
      charger_upload_data_modal: null,

      // session upload
      show_session_upload_modal: false,
      session_upload_data_modal: null,

      show_renewables_upload_modal: false,
      renewables_upload_data_modal: null,

      // session reallocation
      show_session_reallocation_modal: false,
      session_reallocation_data_modal: null,

      // overlap sessions
      show_overlap_sess_modal: false,
      overlap_sess_data_modal: null,

      // Chargers / Sites update details
      show_update_detail_modal: false,
      update_detail_data_modal: null,

      // Motion Bucket download details
      show_motion_bucket_download_modal: false,
      motion_bucket_download_data_modal: null,

      // Sites reset elec region
      show_reset_elec_region_modal: false,
      reset_elec_region_data_modal: null,
      current_row_index: null,
      filterOpen: false,
      filter: {
        fromDate: "",
        toDate: "",
        formKind: "",
        actionKind: "",
        search: "",

        searchByDate: "",
      },
    };
  },
  watch: {
    'filter.searchByDate': function (newVal) {
        // console.log("logDateTime", newVal);
        if (newVal)
          this.handleSearchByDate(newVal);
        else
          this.handleSearchByDate("");
      },

  },
  computed: {
    filter_history() {
      return this.historyDataList;
    },
  },
  mounted() {
    this.fetchHistoryData(this.current_page);
  },
  methods: {

    handleSearchByDate(date) {
      this.filter.fromDate = date;
      this.filter.toDate = date;
      this.fetchHistoryData(this.current_page);
    },

    fetchHistoryData(page) {
      // this.filter.search = this.search;
      UserService.getHistoryLogs(page, this.filter, this.perPageCount)
        .then(
          (response) => {
            const dataList = response.data.history_logs;
            this.historyDataList = dataList.filter((item) => item.form_kind !== "report_snapshot" && item.action_kind !== "create_snapshot");
            this.total_items = response.data.total_record;
            // console.log("total", response.data.total_record);
            // console.log('dataList', this.historyDataList.length);
            
            
            // this.total_items = this.historyDataList.length;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    async handleExportFile() {
      await UserService.getHistoryLogs(1, this.filter, this.perPageCount, true).then(
        async (response) => {
        let dataList = response.data.history_logs;
        
        if (dataList.length > 0) {
          const skipKeys = ["id","user_id","before_change","created_at","updated_at","document_id"]; // Keys to skip
          const fileName = "HistoryLogList.xlsx"; // File name
          const newWorksheetName = "HistoryLog List"; // Worksheet name
          const title = "HistoryLog List"; // Title for the Excel file

          try {

          
          await exportToExcel({
            dataList,
            skipKeys,
            fileName,
            newWorksheetName,
            title,
          });
        } catch (err) {
          console.log("error when export excel", err.message);
          
        }
          } else {
            console.log("empty data list");
          }
      })

    },

    // handleExportFile() {
    //   if (this.filter_history.length > 0) {
    //     const myHeader = [
    //       "full_name",
    //       "phone",
    //       "effective_from",
    //       "country",
    //       "has_user",
    //     ];
    //     const ws = XLSX.utils.json_to_sheet(this.filter_history, {
    //       header: myHeader,
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "HistoryLogList.xlsx");
    //   }
    // },

    reset_filter11(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
      this.fetchHistoryData(this.current_page);
    },

    handleTableAction(event) {
      if (event.kind == "edit") {
        this.handleShow(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        this.fetchHistoryData(this.current_page);
      } else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },

    handleReload() {
      // this.filter.search = event.filter.search;
      // this.filter = event.filter;
      this.fetchHistoryData(this.current_page);
    },
    filterSearch11(event) {
      this.filter.search = event.search;
      this.fetchHistoryData(this.current_page);
    },
    isResetElecRegionLog(data) {
      const formKind = (data?.form_kind || "").toLowerCase();
      const actionKind = (data?.action_kind || "").toLowerCase();
      return formKind === "sites" && actionKind.includes("reset elec");
    },
    isUpdateComment(comment, kind) {
      if (!comment || typeof comment !== "string") return false;
      const c = comment.trim().toLowerCase();
      const k = kind.toLowerCase();
      return c === "update " + k || c === "update " + k + "s" || (c.startsWith("update") && c.includes(k));
    },
    parseHistoryDetails(data) {
      if (!data || !data.before_change) return null;
      try {
        return typeof data.before_change === "string"
          ? JSON.parse(data.before_change)
          : data.before_change;
      } catch (error) {
        return null;
      }
    },
    isMotionBucketDownloadLog(data) {
      const formKind = (data.form_kind || "").toLowerCase();
      const actionKind = (data.action_kind || "").toLowerCase();
      const comment = (data.comment || "").toLowerCase();
      const details = this.parseHistoryDetails(data);
      const hasDownloadedFiles = Array.isArray(details?.files);

      return (
        hasDownloadedFiles &&
        (actionKind.includes("download") || comment.includes("download")) &&
        formKind.includes("bucket")
      );
    },
    handleShow(index, data) {
      if (data.before_change != null && data.before_change != "") {
        this.current_row_index = index;
        
        // Check if it's a Motion Bucket download
        if (this.isMotionBucketDownloadLog(data)) {
          this.motion_bucket_download_data_modal = data;
          this.show_motion_bucket_download_modal = true;
        }

        // Check if it's a Charger Schedule Upload
        else if (data.form_kind === "Charger Schedule" && data.action_kind === "Upload") {
          this.charger_upload_data_modal = data; // Pass the entire data object
          this.show_charger_upload_modal = true;
        }

        // Check if it's a Session Upload
        else if (data.form_kind === "Session Upload" && data.action_kind === "Upload") {
          this.session_upload_data_modal = data; // Pass the entire data object
          this.show_session_upload_modal = true;
        }
        else if (data.form_kind === "Onsite Renewables" && data.action_kind === "Upload") {
          this.renewables_upload_data_modal = data; // Pass the entire data object
          this.show_renewables_upload_modal = true;
        }
        // Check if it's a Sessions Reallocation
        else if (data.form_kind === "Sessions Reallocation") {
          this.session_reallocation_data_modal = data; // Pass the entire data object
          this.show_session_reallocation_modal = true;
        }
        // Check if it's Overlap Sessions
        else if (data.form_kind === "Overlap_Sessions" && data.action_kind === "create") {
          this.overlap_sess_data_modal = data;
          this.show_overlap_sess_modal = true;
        }
        else if (this.isResetElecRegionLog(data)) {
          this.reset_elec_region_data_modal = data;
          this.show_reset_elec_region_modal = true;
        }
        // Check if it's Chargers update, Sites update, or Ports update (by action or comment)
        else if (
          (data.form_kind === "Chargers" && (data.action_kind === "Update" || this.isUpdateComment(data.comment, "chargers"))) ||
          (data.form_kind === "Sites" && (data.action_kind === "Update" || this.isUpdateComment(data.comment, "sites"))) ||
          (data.form_kind === "Ports" && (data.action_kind === "Update" || this.isUpdateComment(data.comment, "ports")))
        ) {
          this.update_detail_data_modal = data;
          this.show_update_detail_modal = true;
        }
        else {
          this.data_modal = data.before_change;
          this.show_modal = true;
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },
    // eslint-disable-next-line no-unused-vars
    close_charger_upload_modal(event) {
      this.show_charger_upload_modal = false;
    },
    // eslint-disable-next-line no-unused-vars
    close_session_upload_modal(event) {
      this.show_session_upload_modal = false;
    },
    // eslint-disable-next-line no-unused-vars
    close_session_reallocation_modal(event) {
      this.show_session_reallocation_modal = false;
    },
    // eslint-disable-next-line no-unused-vars
    close_overlap_sess_modal(event) {
      this.show_overlap_sess_modal = false;
    },
    // eslint-disable-next-line no-unused-vars
    close_update_detail_modal(event) {
      this.show_update_detail_modal = false;
    },
    // eslint-disable-next-line no-unused-vars
    close_motion_bucket_download_modal(event) {
      this.show_motion_bucket_download_modal = false;
    },
    // eslint-disable-next-line no-unused-vars
    close_reset_elec_region_modal(event) {
      this.show_reset_elec_region_modal = false;
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
